@if (aiApiLoaded && assistantDataReady && agentAssociationId) {
  <div class="embed-root"
    [style.--xa-embed-z]="embedOptions.zIndex"
    [style.--xa-embed-primary]="embedOptions.theme.primaryColor"
    [style.--xa-embed-secondary]="embedOptions.theme.secondaryColor"
    [style.--xa-embed-radius]="embedOptions.theme.borderRadius"
    [style.--xa-embed-bg]="embedOptions.theme.backgroundColor"
    [style.--xa-embed-text-primary]="embedOptions.theme.textPrimaryColor"
    [style.--xa-embed-text-secondary]="embedOptions.theme.textSecondaryColor">
    @if (panelOpen) {
      <div
        class="embed-panel"
        [class.embed-panel--fill-viewport]="embedOptions.panelFillViewport"
        [class.embed-panel--host-frame]="panelFillsHostFrame()"
        [style.width]="panelWidthStyle()"
        [style.height]="panelHeightStyle()">
        <div class="assistant-mount">
          <ai-agent-assistant [hideCloseButton]="hideAssistantCloseButton"
            [isGuest]="true"
            [skipAgentDetailApi]="true"
            [agentAssociationId]="agentAssociationId"
            [externalAssistantAvatarUrl]="avatarUrl"
            [externalAssistantName]="assistantName"
            (closed)="onAssistantHeaderClosed()">
          </ai-agent-assistant>
        </div>
      </div>
    }
  </div>
}



@if (aiApiLoaded && !agentAssociationId) {
  <div
    class="no-agent-association">
    <div class="no-agent-association-text">
      {{ 'no_data_available' | translate }}
    </div>
  </div>
}

